<template>
    <app-dropdown :options="mappedOilCoolers" :value="activeOilCooler" @change="handleInput"></app-dropdown>
</template>

<script>
  import {mapState} from 'vuex';
  import Dropdown from "../../input/Dropdown";

  export default {
    name: 'OilCoolerDropdown',

    components: {
      'app-dropdown': Dropdown
    },

    computed: {
      ...mapState({
        activeOilCooler: state => state.build.oilCooler,
        oilCoolers: state => state.oilCoolers.all,
      }),
      mappedOilCoolers() {
        return this.oilCoolers.map(cooler => {
          return {
            key: cooler.id,
            value: this.translate(cooler.name),
          }
        })
      }
    },
    methods: {
      handleInput(id) {
        this.$store.commit('build/setOilCooler', id);
      }
    },
  }
</script>
